import {
    AF_H2H,
    BASEBALL,
    BASKET_BALL,
    BASKET_BALL_EURO,
    BASKET_BALL_NBA,
    CITY_DOGS, CRICKET,
    CYCLING,
    DOGS,
    FIRST_DOWN,
    FOOTBALL,
    FORECAST_CODE,
    HORSES,
    HORSES_SPRINTS,
    MARBLES,
    MATCHDAY,
    MOTOR_RACING,
    NFL,
    NFLA,
    NUMBERS,
    REVERSE_FORECAST_CODE,
    REVERSE_TRICAST_CODE,
    SOCCER3_FOOTBALL,
    SPEEDWAY,
    TENIS, TENNIS,
    TRICAST_CODE,
    TROTTING,
    UNKNOWN
} from '../constants/identifiers';

export function retrieveNextEventsData(nextEventsData) {
    let nextEvents = [];

    if (nextEventsData && nextEventsData.length) {
        nextEvents = nextEventsData.map((ev) => {
            return retrieveEventData(ev);
        });
    }

    return nextEvents;
}

export function retrieveEventData(eventData) {
    let event;

    if (eventData) {
        switch (eventData.eventType) {
            case HORSES:
            case HORSES_SPRINTS:
            case DOGS:
            case CITY_DOGS:
            case SPEEDWAY:
            case MOTOR_RACING:
            case TROTTING:
            case CYCLING:
            case MARBLES:
                event = createRacingEvent(eventData);
                break;
            case FOOTBALL:
                event = createFootballEvent(eventData);
                break;
            case SOCCER3_FOOTBALL:
                event = createSoccer3FootballEvent(eventData);
                break;
            case BASKET_BALL:
            case BASKET_BALL_EURO:
            case BASKET_BALL_NBA:
            case NFLA:
            case AF_H2H:
            case NFL:
                event = createBasketballEvent(eventData);
                break;
            case FIRST_DOWN:
                event = createFirstDownEvent(eventData);
                break;
            case MATCHDAY:
                event = createMatchdayEvent(eventData);
                break;
            case CRICKET:
                event = createCricketEvent(eventData);
                break;
            case TENNIS:
                event = createTennisEvent(eventData);
                break;
            case BASEBALL:
                event = createBaseballEvent(eventData);
                break;
            // these are not supported yet
            case UNKNOWN:
            case NUMBERS:
            case TENIS:
            default:
                break;
        }

    }

    return event;
}

function getTricastOdds(oddsArray, numberOfRacers) {
    let index = 0;
    let oddsMap = {};

    for (let i = 1; i <= numberOfRacers; i++) {
        for (let j = 1; j <= numberOfRacers; j++) {
            for (let k = 1; k <= numberOfRacers; k++) {
                if (i === j || j === k || i === k) {
                    continue;
                }

                oddsMap[`${i}-${j}-${k}`] = oddsArray[index];

                index++;
            }
        }
    }

    return oddsMap;
}

function getReverseTricastOdds(oddsArray, numberOfRacers) {
    let index = 0;
    let oddsMap = {};

    for (let i = 1; i <= numberOfRacers; i++) {
        for (let j = 1; j <= numberOfRacers; j++) {
            for (let k = 1; k <= numberOfRacers; k++) {
                if (i === j || j === k || i === k || j < i || k < j || k < i) {
                    continue;
                }

                oddsMap[`${i}-${j}-${k}`] = oddsArray[index];

                index++;
            }
        }
    }

    return oddsMap;
}

function getForecastOdds(oddsArray, numberOfRacers) {
    let index = 0;
    let oddsMap = {};

    for (let i = 1; i <= numberOfRacers; i++) {
        for (let j = 1; j <= numberOfRacers; j++) {
            if (i === j) {
                continue;
            }

            oddsMap[`${i}-${j}`] = oddsArray[index];

            index++;
        }
    }

    return oddsMap;
}

function getReverseForecastOdds(oddsArray, numberOfRacers) {
    let index = 0;
    let oddsMap = {};

    for (let i = 1; i <= numberOfRacers; i++) {
        for (let j = 1; j <= numberOfRacers; j++) {
            if (i === j || j < i) {
                continue;
            }

            oddsMap[`${i}-${j}`] = oddsArray[index];

            index++;
        }
    }

    return oddsMap;
}

function retrieveEventMarkets(eventMarkets) {
    let markets = [];
    if (eventMarkets && eventMarkets.length) {
        markets = eventMarkets.map(mkt => {
            let mktIdAux = mkt._id.split('_');
            return {
                id: mkt._id,
                code: Number(mktIdAux[0]),
                num: Number(mktIdAux[1]),
                odds: mkt.price,
                selection: mkt.selection,
                //margin: mkt.margin TODO: do we need this???
            };
        });
    }
    return markets;
}

function retrieveEventPriceList(eventPriceList, numberOfRacers) {
    let priceArrayAux;
    let eventPrices = {};
    if (eventPriceList && eventPriceList.length) {
        eventPriceList.map((pl) => {
            priceArrayAux = pl.PRICES.split(',');
            switch (pl.CODE) {
                case FORECAST_CODE:
                    eventPrices.forecast = getForecastOdds(priceArrayAux, numberOfRacers);
                    break;
                case REVERSE_FORECAST_CODE:
                    eventPrices.reverseForecast = getReverseForecastOdds(priceArrayAux, numberOfRacers);
                    break;
                case TRICAST_CODE:
                    eventPrices.tricast = getTricastOdds(priceArrayAux, numberOfRacers);
                    break;
                case REVERSE_TRICAST_CODE:
                    eventPrices.reverseTricast = getReverseTricastOdds(priceArrayAux, numberOfRacers);
                    break;
                default:
                    break;
            }
            return pl;
        });
    }
    return eventPrices;
}

function retrieveEventRacers(eventRacers) {
    let racers = [];
    if (eventRacers && eventRacers.length) {
        racers = eventRacers.map((rcr) => {
            return {
                silk: rcr.HumanTextureID,
                name: rcr.Name,
                num: rcr.Num,
                oddsFirst: rcr.Price,
                oddsPlace: rcr.Place,
                oddsShow: rcr.Show
            };
        });
    }
    return racers;
}

function createRacingEvent(eventData) {
    let event = createEvent(eventData);

    event.courseName = eventData.courseName;
    event.oddsType = eventData.oddsType;
    event.priceList = retrieveEventPriceList(eventData.priceList, eventData.racers);
    event.raceDurationSeconds = eventData.raceLengthS;
    event.racers = retrieveEventRacers(eventData.racerList);
    event.racersCount = eventData.racers;
    event.eachWayRatio = eventData.eachWayRatio;

    return event;
}

function createFootballEvent(eventData) {
    let event = createEvent(eventData);

    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.awayTeamKit = eventData.awayTeamUsesAwayKit;

    return event;
}

function createSoccer3FootballEvent(eventData) {
    let event = createEvent(eventData);

    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.awayTeamKit = 1;
    event.homeKitId = eventData.homeKitId;
    event.awayKitId = eventData.awayKitId;

    return event;
}

function createMatchdayEvent(eventData) {
    let event = createEvent(eventData);

    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.leagueDay = eventData.leagueDay;
    event.order = eventData.order;
    event.homeKitId = eventData.homeKitId;
    event.awayKitId = eventData.awayKitId;

    return event;
}

function createBasketballEvent(eventData) {
    let event = createEvent(eventData);

    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.awayTeamKit = eventData.awayTeamUsesAwayKit;

    return event;
}

function createFirstDownEvent(eventData) {
    let event = createEvent(eventData);

    event.defenseTeam = eventData.DefenseTeam;
    event.offenseTeam = eventData.OffenseTeam;

    if (eventData.details !== null) {
        let tokens = eventData.details.split(",");
        let whoAttacks = tokens[1].trimStart().split(' ')[0];
        if (whoAttacks === 'Home') {
            event.homeTeam = eventData.OffenseTeam;
            event.awayTeam = eventData.DefenseTeam;
        } else {
            event.homeTeam = eventData.DefenseTeam;
            event.awayTeam = eventData.OffenseTeam;
        }
    }
    event.meetingName = eventData.MeetingName;
    event.startLine = eventData.StartLine;
    event.details = eventData.details;

    return event;
}

function createEvent(eventData) {
    let timeDate = new Date(eventData.eventTime).getTime();
    return {
        title: eventData.TITLE,
        channel: eventData.channel,
        eventId: eventData.eventId,
        eventTime: eventData.eventTime,
        eventTimeDate: timeDate,
        eventType: eventData.eventType,
        markets: retrieveEventMarkets(eventData.markets),
        noMoreBets: eventData.noMoreBets,
        eventUUID: eventData._id
    };
}

function createCricketEvent(eventData) {
    let event = createEvent(eventData);
    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.awayTeamKit = 1;
    event.homeKitId = eventData.homeKitId;
    event.awayKitId = eventData.awayKitId;
    return event;
}
function createTennisEvent(eventData) {
    let event = createEvent(eventData);
    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.title=eventData.TITLE;
    event.homeKitId = eventData.homeKitId;
    event.awayKitId = eventData.awayKitId;
    event.playerOne = eventData.player1;
    event.playerTwo = eventData.player2;
    return event;
}

function createBaseballEvent(eventData) {
    let event = createEvent(eventData);
    event.stadium = eventData.stadium;
    event.teamOne = eventData.t1;
    event.teamTwo = eventData.t2;
    event.title=eventData.TITLE;
    event.homeKitId = eventData.homeKitId;
    event.awayKitId = eventData.awayKitId;
    event.playerOne = eventData.player1;
    event.playerTwo = eventData.player2;
    event.awayUsesAlternateKit = eventData.awayUsesAlternateKit;
    event.homeUsesAlternateKit = eventData.homeUsesAlternateKit;
    return event;
}


// WEBPACK FOOTER //
// ./src/communications/platformMessageHelpers.js